import { Component, OnDestroy } from '@angular/core';
import { SystemNotificationService } from '../../services/system-notification.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { SystemsNotificationsCreateDialogComponent } from '../SystemsNotificationsCreateDialog/systems-notifications-create-dialog.component';
import { SystemNotificationsDetailsEnum } from '../../enums/system-notifications-details.enum';
import { SystemNotificationModel } from '../../models/system-notification.model';
import { Subscription } from 'rxjs';
import { AttributeModel } from '../../../../Common/Misc/models/attribute.model';
import { attributeTypesEnum } from '../../../../Common/Misc/enums/attribute-types.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
@Component({
    selector: 'agpr-systems-notifications',
    templateUrl: './systems-notifications.component.html',
    styleUrls: ['./systems-notifications.component.scss'],
    providers: [
        {
            provide: FilterService,
            useExisting: SystemNotificationService
        }
    ],
    standalone: false
})
export class SystemsNotificationsComponent implements OnDestroy {
    readonly systemNotificationsDetailsEnum = SystemNotificationsDetailsEnum;
    readonly attributeTypesEnum = attributeTypesEnum;
    readonly buttonTypes = ButtonTypesEnum;

    focusedNotification: SystemNotificationModel;
    subscriptions: Subscription[] = [];
    notificationList: SystemNotificationModel[] = [];
    notificationDetails: AttributeModel[] = [];
    selectedNotifications: SystemNotificationModel[] = [];
    loading: boolean = false;

    constructor(
        private coreDialogService: CoreDialogService,
        private systemNotificationService: SystemNotificationService
    ) {
        this.subscriptions.push(
            this.systemNotificationService.getNotificationList().subscribe(list => {
                this.notificationList = list;
                if (this.notificationList) {
                    this.notificationList.sort(
                        (a, b) => {
                            const bSortDate = b.modifiedDate ? +b.modifiedDate : +b.createdDate;
                            const aSortDate = a.modifiedDate ? +a.modifiedDate : +a.createdDate;
                            return bSortDate - aSortDate;
                        });

                    // set focus to the first mention
                    this.systemNotificationService.setFocusedNotification(this.notificationList[0]);
                }
            }),
            this.systemNotificationService.getFocusedNotification().subscribe(result => {
                if (result) {
                    this.focusedNotification = result;
                    this.setNotificationDetails();
                }
            }),
            this.systemNotificationService.getLoading().subscribe(loading => {
                this.selectedNotifications = [];
                this.loading = loading;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    setNotificationDetails() {
        if (!this.focusedNotification) {
            this.notificationDetails = [];
            return;
        }
        const createdBy: AttributeModel = {
            id: this.systemNotificationsDetailsEnum.createdBy,
            label: 'createdBy',
            value: this.focusedNotification.createdByUserId,
            type: attributeTypesEnum.user
        };

        const createdDate: AttributeModel = {
            id: this.systemNotificationsDetailsEnum.createdDate,
            label: 'dateCreated',
            value: this.focusedNotification.createdDate,
            type: attributeTypesEnum.date
        };

        const lastModifiedBy: AttributeModel = {
            id: this.systemNotificationsDetailsEnum.lastModifiedBy,
            label: 'lastModifiedBy',
            value: this.focusedNotification.modifiedByUserId,
            type: attributeTypesEnum.user

        };

        const lastModifiedDate: AttributeModel = {
            id: this.systemNotificationsDetailsEnum.lastModifiedDate,
            label: 'lastModifiedDate',
            value: this.focusedNotification.modifiedDate,
            type: attributeTypesEnum.date
        };

        this.notificationDetails = [
            createdBy,
            createdDate,
            lastModifiedBy,
            lastModifiedDate
        ].filter(x => !!x.value);

    }

    deleteNotifications() {
        this.systemNotificationService.deleteNotifications(this.selectedNotifications);
    }

    openCreateDialog(): void {
        this.coreDialogService.open(SystemsNotificationsCreateDialogComponent);
    }
}
